import { render, staticRenderFns } from "./card-typing.vue?vue&type=template&id=64305c13&scoped=true&"
import script from "./card-typing.vue?vue&type=script&lang=js&"
export * from "./card-typing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64305c13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VSlider})
